module.exports = __webpack_public_path__ + "media/images/default/shared/header/nav-cover4-a956a583ab4fb91cdef17691ebac4ab0.jpg";